// A plan's progress over the issues it lists (today's components/bits.tsx, ProgressBar).
import type { Progress } from './state'

export function ProgressBar({ progress, label }: { progress: Progress; label?: string }) {
  const ratio = progress.total ? progress.done / progress.total : 0
  const text = `${progress.done} of ${progress.total} done`
  return (
    <span className="progress" title={label ? `${label}: ${text}` : text}>
      <span className="progress-track" role="progressbar" aria-valuemin={0} aria-valuemax={progress.total} aria-valuenow={progress.done} aria-label={label ?? 'Progress'}>
        <span className="progress-fill" style={{ width: `${Math.round(ratio * 100)}%` }} />
      </span>
      <span className="progress-count">
        {progress.done}/{progress.total}
      </span>
    </span>
  )
}
